import { SignOutFn } from "../../rest/Login";
import { Command } from "../../Command";

export class SignOutCommand implements Command
{
    constructor(private signOut: SignOutFn, private removeAuthCookies: () => void, private redirect: () => void)
    {
    }

    takeMeToLogin() {
        let uri;
        if(window.location.origin.includes('localhost')){
            uri = `${window.location.origin}/output/login/index.html`;
        }else{
            uri = `${window.location.origin}/login`;
        }
        
        window.location.href = `https://my.spartansense.com:8443/auth/realms/spartanlync/protocol/openid-connect/logout?redirect_uri=${uri}`;
    }
    
    execute = () => {
        this.signOut().then(() => {
            this.removeAuthCookies();
            this.takeMeToLogin();
            // this.redirect();
        });
    };
}


// WEBPACK FOOTER //
// ./src/login/commands/SignOutCommand.ts